import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/bookingActions'
import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchBookingOrganizations = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.B_ORGANIZATIONS_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.bookingOrganizations, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.b_fetchOrganizationsSuccess(getParser(urls.bookingOrganizations)(json))))
        .catch(
            handleError(
                dispatch,
                actions.b_fetchOrganizationsFailure,
                'Что-то пошло не так!',
                'При получении организаций произошла ошибка'
            )
        )
}

/** @thunk **/
export const postBookingOrganization = organization => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(organization)
    }
    const { auth } = getState()

    securedFetch(urls.bookingOrganizations, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.b_saveOrganizationsSuccess(json)))
        .then(() => toastr.success('Организация добавлена'))
        .catch(
            handleError(
                dispatch,
                actions.b_saveOrganizationsFailure,
                'Что-то пошло не так!',
                'При сохранении организации произошла ошибка'
            )
        )
}

/** @thunk **/
export const updateBookingOrganization = (remoteId, payload) => (dispatch, getState) => {
    // prettier-ignore
    const { bookingOrganizations: { entities: { organizations } } } = getState()
    const { auth } = getState()

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...organizations[remoteId], ...payload })
    }

    securedFetch(urls.bookingOrganizations, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.b_updateOrganizationsSuccess(json)))
        .then(() => toastr.success('Организация обновлена'))
        .catch(
            handleError(
                dispatch,
                actions.b_updateOrganizationsFailure,
                'Что-то пошло не так!',
                'При обновлении организации произошла ошибка'
            )
        )
}

/** @thunk **/
export const deleteBookingOrganization = remoteId => (dispatch, getState) => {
    const { auth } = getState()

    securedFetch(urls.bookingOrganizationSelf(remoteId), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(() => dispatch(actions.b_deleteOrganizationSuccess(remoteId)))
        .then(() => toastr.success('Организация удалена'))
        .catch(
            handleError(
                dispatch,
                actions.b_deleteOrganizationFailure,
                'Что-то пошло не так!',
                'При удалении организации произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/bookingApi/bookingOrganizations.js